/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as WelcomeRouteImport } from "./routes/welcome";
import { Route as TonightModeRouteImport } from "./routes/tonight-mode";
import { Route as SendDrinkRouteImport } from "./routes/send-drink";
import { Route as ScreenRouteImport } from "./routes/screen";
import { Route as RoomRouteImport } from "./routes/room";
import { Route as RequestsRouteImport } from "./routes/requests";
import { Route as ProfileRouteImport } from "./routes/profile";
import { Route as LineProfileRouteImport } from "./routes/line-profile";
import { Route as JoinTableRouteImport } from "./routes/join-table";
import { Route as GamesRouteImport } from "./routes/games";
import { Route as CartRouteImport } from "./routes/cart";
import { Route as BlockedRouteImport } from "./routes/blocked";
import { Route as AgeGateRouteImport } from "./routes/age-gate";
import { Route as TabsRouteImport } from "./routes/_tabs";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as TablesTableIdRouteImport } from "./routes/tables.$tableId";
import { Route as OrdersOrderIdRouteImport } from "./routes/orders.$orderId";
import { Route as TabsMenuRouteImport } from "./routes/_tabs/menu";
import { Route as TabsMeRouteImport } from "./routes/_tabs/me";
import { Route as TabsHomeRouteImport } from "./routes/_tabs/home";
import { Route as TabsAroundRouteImport } from "./routes/_tabs/around";
import { Route as TabsGiftsIncomingRouteImport } from "./routes/_tabs/gifts.incoming";

const WelcomeRoute = WelcomeRouteImport.update({
  id: "/welcome",
  path: "/welcome",
  getParentRoute: () => rootRouteImport,
} as any);
const TonightModeRoute = TonightModeRouteImport.update({
  id: "/tonight-mode",
  path: "/tonight-mode",
  getParentRoute: () => rootRouteImport,
} as any);
const SendDrinkRoute = SendDrinkRouteImport.update({
  id: "/send-drink",
  path: "/send-drink",
  getParentRoute: () => rootRouteImport,
} as any);
const ScreenRoute = ScreenRouteImport.update({
  id: "/screen",
  path: "/screen",
  getParentRoute: () => rootRouteImport,
} as any);
const RoomRoute = RoomRouteImport.update({
  id: "/room",
  path: "/room",
  getParentRoute: () => rootRouteImport,
} as any);
const RequestsRoute = RequestsRouteImport.update({
  id: "/requests",
  path: "/requests",
  getParentRoute: () => rootRouteImport,
} as any);
const ProfileRoute = ProfileRouteImport.update({
  id: "/profile",
  path: "/profile",
  getParentRoute: () => rootRouteImport,
} as any);
const LineProfileRoute = LineProfileRouteImport.update({
  id: "/line-profile",
  path: "/line-profile",
  getParentRoute: () => rootRouteImport,
} as any);
const JoinTableRoute = JoinTableRouteImport.update({
  id: "/join-table",
  path: "/join-table",
  getParentRoute: () => rootRouteImport,
} as any);
const GamesRoute = GamesRouteImport.update({
  id: "/games",
  path: "/games",
  getParentRoute: () => rootRouteImport,
} as any);
const CartRoute = CartRouteImport.update({
  id: "/cart",
  path: "/cart",
  getParentRoute: () => rootRouteImport,
} as any);
const BlockedRoute = BlockedRouteImport.update({
  id: "/blocked",
  path: "/blocked",
  getParentRoute: () => rootRouteImport,
} as any);
const AgeGateRoute = AgeGateRouteImport.update({
  id: "/age-gate",
  path: "/age-gate",
  getParentRoute: () => rootRouteImport,
} as any);
const TabsRoute = TabsRouteImport.update({
  id: "/_tabs",
  getParentRoute: () => rootRouteImport,
} as any);
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const TablesTableIdRoute = TablesTableIdRouteImport.update({
  id: "/tables/$tableId",
  path: "/tables/$tableId",
  getParentRoute: () => rootRouteImport,
} as any);
const OrdersOrderIdRoute = OrdersOrderIdRouteImport.update({
  id: "/orders/$orderId",
  path: "/orders/$orderId",
  getParentRoute: () => rootRouteImport,
} as any);
const TabsMenuRoute = TabsMenuRouteImport.update({
  id: "/menu",
  path: "/menu",
  getParentRoute: () => TabsRoute,
} as any);
const TabsMeRoute = TabsMeRouteImport.update({
  id: "/me",
  path: "/me",
  getParentRoute: () => TabsRoute,
} as any);
const TabsHomeRoute = TabsHomeRouteImport.update({
  id: "/home",
  path: "/home",
  getParentRoute: () => TabsRoute,
} as any);
const TabsAroundRoute = TabsAroundRouteImport.update({
  id: "/around",
  path: "/around",
  getParentRoute: () => TabsRoute,
} as any);
const TabsGiftsIncomingRoute = TabsGiftsIncomingRouteImport.update({
  id: "/gifts/incoming",
  path: "/gifts/incoming",
  getParentRoute: () => TabsRoute,
} as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/age-gate": typeof AgeGateRoute;
  "/blocked": typeof BlockedRoute;
  "/cart": typeof CartRoute;
  "/games": typeof GamesRoute;
  "/join-table": typeof JoinTableRoute;
  "/line-profile": typeof LineProfileRoute;
  "/profile": typeof ProfileRoute;
  "/requests": typeof RequestsRoute;
  "/room": typeof RoomRoute;
  "/screen": typeof ScreenRoute;
  "/send-drink": typeof SendDrinkRoute;
  "/tonight-mode": typeof TonightModeRoute;
  "/welcome": typeof WelcomeRoute;
  "/around": typeof TabsAroundRoute;
  "/home": typeof TabsHomeRoute;
  "/me": typeof TabsMeRoute;
  "/menu": typeof TabsMenuRoute;
  "/orders/$orderId": typeof OrdersOrderIdRoute;
  "/tables/$tableId": typeof TablesTableIdRoute;
  "/gifts/incoming": typeof TabsGiftsIncomingRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/age-gate": typeof AgeGateRoute;
  "/blocked": typeof BlockedRoute;
  "/cart": typeof CartRoute;
  "/games": typeof GamesRoute;
  "/join-table": typeof JoinTableRoute;
  "/line-profile": typeof LineProfileRoute;
  "/profile": typeof ProfileRoute;
  "/requests": typeof RequestsRoute;
  "/room": typeof RoomRoute;
  "/screen": typeof ScreenRoute;
  "/send-drink": typeof SendDrinkRoute;
  "/tonight-mode": typeof TonightModeRoute;
  "/welcome": typeof WelcomeRoute;
  "/around": typeof TabsAroundRoute;
  "/home": typeof TabsHomeRoute;
  "/me": typeof TabsMeRoute;
  "/menu": typeof TabsMenuRoute;
  "/orders/$orderId": typeof OrdersOrderIdRoute;
  "/tables/$tableId": typeof TablesTableIdRoute;
  "/gifts/incoming": typeof TabsGiftsIncomingRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_tabs": typeof TabsRouteWithChildren;
  "/age-gate": typeof AgeGateRoute;
  "/blocked": typeof BlockedRoute;
  "/cart": typeof CartRoute;
  "/games": typeof GamesRoute;
  "/join-table": typeof JoinTableRoute;
  "/line-profile": typeof LineProfileRoute;
  "/profile": typeof ProfileRoute;
  "/requests": typeof RequestsRoute;
  "/room": typeof RoomRoute;
  "/screen": typeof ScreenRoute;
  "/send-drink": typeof SendDrinkRoute;
  "/tonight-mode": typeof TonightModeRoute;
  "/welcome": typeof WelcomeRoute;
  "/_tabs/around": typeof TabsAroundRoute;
  "/_tabs/home": typeof TabsHomeRoute;
  "/_tabs/me": typeof TabsMeRoute;
  "/_tabs/menu": typeof TabsMenuRoute;
  "/orders/$orderId": typeof OrdersOrderIdRoute;
  "/tables/$tableId": typeof TablesTableIdRoute;
  "/_tabs/gifts/incoming": typeof TabsGiftsIncomingRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/age-gate"
    | "/blocked"
    | "/cart"
    | "/games"
    | "/join-table"
    | "/line-profile"
    | "/profile"
    | "/requests"
    | "/room"
    | "/screen"
    | "/send-drink"
    | "/tonight-mode"
    | "/welcome"
    | "/around"
    | "/home"
    | "/me"
    | "/menu"
    | "/orders/$orderId"
    | "/tables/$tableId"
    | "/gifts/incoming";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/age-gate"
    | "/blocked"
    | "/cart"
    | "/games"
    | "/join-table"
    | "/line-profile"
    | "/profile"
    | "/requests"
    | "/room"
    | "/screen"
    | "/send-drink"
    | "/tonight-mode"
    | "/welcome"
    | "/around"
    | "/home"
    | "/me"
    | "/menu"
    | "/orders/$orderId"
    | "/tables/$tableId"
    | "/gifts/incoming";
  id:
    | "__root__"
    | "/"
    | "/_tabs"
    | "/age-gate"
    | "/blocked"
    | "/cart"
    | "/games"
    | "/join-table"
    | "/line-profile"
    | "/profile"
    | "/requests"
    | "/room"
    | "/screen"
    | "/send-drink"
    | "/tonight-mode"
    | "/welcome"
    | "/_tabs/around"
    | "/_tabs/home"
    | "/_tabs/me"
    | "/_tabs/menu"
    | "/orders/$orderId"
    | "/tables/$tableId"
    | "/_tabs/gifts/incoming";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  TabsRoute: typeof TabsRouteWithChildren;
  AgeGateRoute: typeof AgeGateRoute;
  BlockedRoute: typeof BlockedRoute;
  CartRoute: typeof CartRoute;
  GamesRoute: typeof GamesRoute;
  JoinTableRoute: typeof JoinTableRoute;
  LineProfileRoute: typeof LineProfileRoute;
  ProfileRoute: typeof ProfileRoute;
  RequestsRoute: typeof RequestsRoute;
  RoomRoute: typeof RoomRoute;
  ScreenRoute: typeof ScreenRoute;
  SendDrinkRoute: typeof SendDrinkRoute;
  TonightModeRoute: typeof TonightModeRoute;
  WelcomeRoute: typeof WelcomeRoute;
  OrdersOrderIdRoute: typeof OrdersOrderIdRoute;
  TablesTableIdRoute: typeof TablesTableIdRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/welcome": {
      id: "/welcome";
      path: "/welcome";
      fullPath: "/welcome";
      preLoaderRoute: typeof WelcomeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/tonight-mode": {
      id: "/tonight-mode";
      path: "/tonight-mode";
      fullPath: "/tonight-mode";
      preLoaderRoute: typeof TonightModeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/send-drink": {
      id: "/send-drink";
      path: "/send-drink";
      fullPath: "/send-drink";
      preLoaderRoute: typeof SendDrinkRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/screen": {
      id: "/screen";
      path: "/screen";
      fullPath: "/screen";
      preLoaderRoute: typeof ScreenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/room": {
      id: "/room";
      path: "/room";
      fullPath: "/room";
      preLoaderRoute: typeof RoomRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/requests": {
      id: "/requests";
      path: "/requests";
      fullPath: "/requests";
      preLoaderRoute: typeof RequestsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/profile": {
      id: "/profile";
      path: "/profile";
      fullPath: "/profile";
      preLoaderRoute: typeof ProfileRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/line-profile": {
      id: "/line-profile";
      path: "/line-profile";
      fullPath: "/line-profile";
      preLoaderRoute: typeof LineProfileRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/join-table": {
      id: "/join-table";
      path: "/join-table";
      fullPath: "/join-table";
      preLoaderRoute: typeof JoinTableRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/games": {
      id: "/games";
      path: "/games";
      fullPath: "/games";
      preLoaderRoute: typeof GamesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/cart": {
      id: "/cart";
      path: "/cart";
      fullPath: "/cart";
      preLoaderRoute: typeof CartRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/blocked": {
      id: "/blocked";
      path: "/blocked";
      fullPath: "/blocked";
      preLoaderRoute: typeof BlockedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/age-gate": {
      id: "/age-gate";
      path: "/age-gate";
      fullPath: "/age-gate";
      preLoaderRoute: typeof AgeGateRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_tabs": {
      id: "/_tabs";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof TabsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/tables/$tableId": {
      id: "/tables/$tableId";
      path: "/tables/$tableId";
      fullPath: "/tables/$tableId";
      preLoaderRoute: typeof TablesTableIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/orders/$orderId": {
      id: "/orders/$orderId";
      path: "/orders/$orderId";
      fullPath: "/orders/$orderId";
      preLoaderRoute: typeof OrdersOrderIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_tabs/menu": {
      id: "/_tabs/menu";
      path: "/menu";
      fullPath: "/menu";
      preLoaderRoute: typeof TabsMenuRouteImport;
      parentRoute: typeof TabsRoute;
    };
    "/_tabs/me": {
      id: "/_tabs/me";
      path: "/me";
      fullPath: "/me";
      preLoaderRoute: typeof TabsMeRouteImport;
      parentRoute: typeof TabsRoute;
    };
    "/_tabs/home": {
      id: "/_tabs/home";
      path: "/home";
      fullPath: "/home";
      preLoaderRoute: typeof TabsHomeRouteImport;
      parentRoute: typeof TabsRoute;
    };
    "/_tabs/around": {
      id: "/_tabs/around";
      path: "/around";
      fullPath: "/around";
      preLoaderRoute: typeof TabsAroundRouteImport;
      parentRoute: typeof TabsRoute;
    };
    "/_tabs/gifts/incoming": {
      id: "/_tabs/gifts/incoming";
      path: "/gifts/incoming";
      fullPath: "/gifts/incoming";
      preLoaderRoute: typeof TabsGiftsIncomingRouteImport;
      parentRoute: typeof TabsRoute;
    };
  }
}

interface TabsRouteChildren {
  TabsAroundRoute: typeof TabsAroundRoute;
  TabsHomeRoute: typeof TabsHomeRoute;
  TabsMeRoute: typeof TabsMeRoute;
  TabsMenuRoute: typeof TabsMenuRoute;
  TabsGiftsIncomingRoute: typeof TabsGiftsIncomingRoute;
}

const TabsRouteChildren: TabsRouteChildren = {
  TabsAroundRoute: TabsAroundRoute,
  TabsHomeRoute: TabsHomeRoute,
  TabsMeRoute: TabsMeRoute,
  TabsMenuRoute: TabsMenuRoute,
  TabsGiftsIncomingRoute: TabsGiftsIncomingRoute,
};

const TabsRouteWithChildren = TabsRoute._addFileChildren(TabsRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TabsRoute: TabsRouteWithChildren,
  AgeGateRoute: AgeGateRoute,
  BlockedRoute: BlockedRoute,
  CartRoute: CartRoute,
  GamesRoute: GamesRoute,
  JoinTableRoute: JoinTableRoute,
  LineProfileRoute: LineProfileRoute,
  ProfileRoute: ProfileRoute,
  RequestsRoute: RequestsRoute,
  RoomRoute: RoomRoute,
  ScreenRoute: ScreenRoute,
  SendDrinkRoute: SendDrinkRoute,
  TonightModeRoute: TonightModeRoute,
  WelcomeRoute: WelcomeRoute,
  OrdersOrderIdRoute: OrdersOrderIdRoute,
  TablesTableIdRoute: TablesTableIdRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
